// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var PasswordResetCompletePhase = function (x) {
    return x;
};
var tsBridgePasswordResetComp = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeIntersection([ new DTS_Types.TsTypeUnion([ new DTS_Types.TsTypeTypelevelString("form"), new DTS_Types.TsTypeTypelevelString("missingToken") ]), new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("__brandPasswordResetCompletePhase", {
            readonly: true,
            optional: false
        }, new DTS_Types.TsTypeTypelevelString("PasswordResetCompletePhase")) ]) ]));
    }
};
var showPasswordResetCompletePhase = Data_Show.showString;
var passwordResetCompletePhaseToString = function (v) {
    return v;
};
var writePasswordResetCompletePhase = {
    writeImpl: /* #__PURE__ */ (function () {
        var $19 = Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
        return function ($20) {
            return $19(passwordResetCompletePhaseToString($20));
        };
    })()
};
var passwordResetCompletePhaseMissingToken = "missingToken";
var passwordResetCompletePhaseForm = "form";
var passwordResetCompletePhaseFromString = function (value) {
    if (value === "form") {
        return new Data_Maybe.Just(passwordResetCompletePhaseForm);
    };
    if (value === "missingToken") {
        return new Data_Maybe.Just(passwordResetCompletePhaseMissingToken);
    };
    return Data_Maybe.Nothing.value;
};
var readPasswordResetCompletePhase = {
    readImpl: function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = passwordResetCompletePhaseFromString(raw);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid PasswordResetCompletePhase: " + raw));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Ui.PasswordResetCompletePhase (line 54, column 5 - line 56, column 93): " + [ v.constructor.name ]);
        });
    }
};
var passwordResetCompletePhaseNamespace = {
    form: passwordResetCompletePhaseForm,
    missingToken: passwordResetCompletePhaseMissingToken
};
var ordPasswordResetCompletePhase = Data_Ord.ordString;
var eqPasswordResetCompletePhase = Data_Eq.eqString;
export {
    passwordResetCompletePhaseForm,
    passwordResetCompletePhaseMissingToken,
    passwordResetCompletePhaseNamespace,
    passwordResetCompletePhaseFromString,
    passwordResetCompletePhaseToString,
    eqPasswordResetCompletePhase,
    ordPasswordResetCompletePhase,
    showPasswordResetCompletePhase,
    readPasswordResetCompletePhase,
    writePasswordResetCompletePhase,
    tsBridgePasswordResetComp
};
//# sourceMappingURL=index.js.map
